import { gql } from '@apollo/client';

export class LoginGQLFunction {
  static LOGIN = gql`
    mutation login($email: String!, $password: String!) {
      login(email: $email, password: $password) {
        token
        err
        msg
        adminName
        adminId
        cn
        domain
      }
    }
  `;

  static LOGOUT = gql`
    mutation logout($token: String!) {
      logout(token: $token)
    }
  `;
}
